import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    key: { type: String, default: "healthsetu-theme" }
  }

  connect() {
    this.apply(this.savedTheme())
  }

  toggle() {
    const nextTheme = this.currentTheme() === "light" ? "dark" : "light"
    window.localStorage.setItem(this.keyValue, nextTheme)
    this.apply(nextTheme)
  }

  currentTheme() {
    return document.documentElement.dataset.theme || "light"
  }

  savedTheme() {
    return window.localStorage.getItem(this.keyValue) ||
      (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light")
  }

  apply(theme) {
    document.documentElement.dataset.theme = theme
  }
}
